
    import * as React from 'react';

    const SocialTwitter16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M14 4.184a4.822 4.822 0 01-1.414.397 2.527 2.527 0 001.083-1.396 4.861 4.861 0 01-1.564.611A2.433 2.433 0 0010.308 3c-1.36 0-2.462 1.13-2.462 2.524 0 .198.022.39.064.575-2.046-.105-3.86-1.11-5.075-2.637a2.564 2.564 0 00-.333 1.27c0 .875.434 1.648 1.096 2.1a2.399 2.399 0 01-1.115-.315l-.001.031c0 1.224.85 2.242 1.975 2.475a2.402 2.402 0 01-1.112.044c.314 1.002 1.222 1.732 2.3 1.753A4.863 4.863 0 012 11.865 6.842 6.842 0 005.774 13c4.529 0 7.005-3.847 7.005-7.183 0-.11-.003-.218-.007-.327.48-.356.898-.8 1.228-1.306" fillRule="evenodd" /></svg>
        </div>
      );
    };

    SocialTwitter16.displayName = 'SocialTwitter16';

    export default SocialTwitter16;
  